import { __assign as e } from "../../node_modules/tslib/tslib.es6.js";
import r from "react";
var t = function t(_t) {
  var o = _t.children,
    i = _t.style;
  return r.createElement("div", {
    className: "storyblok-image-wrapper",
    style: e({
      position: "relative",
      overflow: "hidden"
    }, i)
  }, o);
};
export { t as Wrapper };